import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { fontBold, fontRegular } from "../../../utils/fontFamily"
import {
  megaMenuTheme,
  borderTheme,
  headlineTextTheme,
  brandAccentColor,
} from "../../../theme"
import SmallFunnel from "../../../images/platform/funnel-small.svg"
import FeaturesGraphics from "../../../images/features/features-mega-image.png"
import ResourcesGraphic from "../../../images/resources-mega-small.png"
import { useTheme } from "../../../context/ThemeContext"
import { StandardPlanName } from "../../../utils/enumUtil"
import config from "../../../config/config"

const PlatformMenuMenu = ({
  platformMenuOpen,
  onTrialClick,
  onLinkClick,
  pricingLink,
}) => {
  return (
    <MegaMenu className={platformMenuOpen ? "reveal" : ""}>
      <MegaMenuContainer>
        <MegaMenuMain>
          <MegaMenuMainInner>
            <MegaMenuSubNav>
              <h4>Platform</h4>
              <MegaMenuMainNav>
                <MegaMenuMainNavItem>
                  <Link
                    to="/platform/salesfunnel/"
                    onClick={() => onLinkClick()}
                  >
                    Sales Funnel
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link to="/platform/campaigns/" onClick={() => onLinkClick()}>
                    Text & Email Campaigns
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="/platform/contact-management/"
                    onClick={() => onLinkClick()}
                  >
                    Contact Management
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="/platform/mobile-landing-pages/"
                    onClick={() => onLinkClick()}
                  >
                    Mobile Landing Pages
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="/platform/automation/"
                    onClick={() => onLinkClick()}
                  >
                    Advanced Automation
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="/platform/payments-billing/"
                    onClick={() => onLinkClick()}
                  >
                    Payments & Billing
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link to="/platform/offers/" onClick={() => onLinkClick()}>
                    Digital Offers
                  </Link>
                </MegaMenuMainNavItem>
              </MegaMenuMainNav>
            </MegaMenuSubNav>
            <MegaMenuMainGraphic>
              <img src={SmallFunnel} />
              <p>
                <em>
                  Features designed for every step of the{" "}
                  <strong>Customer Journey</strong>
                </em>
              </p>
            </MegaMenuMainGraphic>
          </MegaMenuMainInner>
        </MegaMenuMain>
        <MegaMenuSecondary>
          <div>
            <h4>Info</h4>
            <MegaMenuMainNav>
              {/* <MegaMenuMainNavItem>
                <Link
                  to="https://meetings.hubspot.com/bert/mindme-demo"
                  target="_blank"
                >
                  Schedule Demo
                </Link>
              </MegaMenuMainNavItem> */}
              <MegaMenuMainNavItem>
                <Link to="/support/" onClick={() => onLinkClick()}>
                  Get Support
                </Link>
              </MegaMenuMainNavItem>
              {/* <MegaMenuMainNavItem>Referral Program</MegaMenuMainNavItem> */}
            </MegaMenuMainNav>
          </div>
          <div>
            <h4>Access</h4>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to={`${config.WEB_ENDPOINT}login`} target="_blank">
                  Account Login
                </Link>
              </MegaMenuMainNavItem>
              <MegaMenuMainNavItem>
                <Link
                  to={`${config.AFFILIATE_WEB_ENDPOINT}affiliate/login`}
                  target="_blank"
                >
                  Affiliate Login
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
          <div>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to="/platform/app/" onClick={() => onLinkClick()}>
                  Mobile App
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
          <div>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to={pricingLink} onClick={() => onLinkClick()}>
                  View Plans
                </Link>
              </MegaMenuMainNavItem>
              <MegaMenuMainNavItem onClick={(event) => onTrialClick(event)}>
                Free Trial
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
        </MegaMenuSecondary>
      </MegaMenuContainer>
    </MegaMenu>
  )
}

const FeaturesMegaMenu = ({
  featuresMenuOpen,
  onTrialClick,
  onLinkClick,
  pricingLink,
}) => {
  return (
    <MegaMenu className={featuresMenuOpen ? "reveal" : ""}>
      <MegaMenuContainer>
        <MegaMenuMain>
          <MegaMenuMainInner>
            <MegaMenuSubNav>
              <h4>Features</h4>
              <MegaMenuMainNav>
                <MegaMenuMainNavItem>
                  <Link
                    to="/features/intelligent-delivery/"
                    onClick={() => onLinkClick()}
                  >
                    Intelligent Delivery
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="/features/custom-domains/"
                    onClick={() => onLinkClick()}
                  >
                    Custom Domains
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="/features/smartlists-and-filters/"
                    onClick={() => onLinkClick()}
                  >
                    Smart Lists & Filters
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link to="/features/library/" onClick={() => onLinkClick()}>
                    Resource Library
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link to="/features/reporting/" onClick={() => onLinkClick()}>
                    Reporting
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link to="/features/actions/" onClick={() => onLinkClick()}>
                    Actions
                  </Link>
                </MegaMenuMainNavItem>
              </MegaMenuMainNav>
            </MegaMenuSubNav>
            <MegaMenuMainGraphic>
              <img src={FeaturesGraphics} />
              <p>
                <em>
                  Deliver your communication and engage your audience with{" "}
                  <strong>Intelligent Delivery</strong>
                </em>
              </p>
            </MegaMenuMainGraphic>
          </MegaMenuMainInner>
        </MegaMenuMain>
        <MegaMenuSecondary>
          <div>
            <h4>Info</h4>
            <MegaMenuMainNav>
              {/* <MegaMenuMainNavItem>
                <Link
                  to="https://meetings.hubspot.com/bert/mindme-demo"
                  target="_blank"
                >
                  Schedule Demo
                </Link>
              </MegaMenuMainNavItem> */}
              <MegaMenuMainNavItem>
                <Link to="/support/">Get Support</Link>
              </MegaMenuMainNavItem>
              {/* <MegaMenuMainNavItem>Referral Program</MegaMenuMainNavItem> */}
            </MegaMenuMainNav>
          </div>
          <div>
            <h4>Access</h4>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to={`${config.WEB_ENDPOINT}login`} target="_blank">
                  Account Login
                </Link>
              </MegaMenuMainNavItem>
              <MegaMenuMainNavItem>
                <Link
                  to={`${config.AFFILIATE_WEB_ENDPOINT}affiliate/login`}
                  target="_blank"
                >
                  Affiliate Login
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
          <div>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to="/platform/app/" onClick={() => onLinkClick()}>
                  Mobile App
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
          <div>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to={pricingLink} onClick={() => onLinkClick()}>
                  View Plans
                </Link>
              </MegaMenuMainNavItem>
              <MegaMenuMainNavItem>
                <Link to={pricingLink} onClick={(event) => onTrialClick(event)}>
                  Free Trial
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
        </MegaMenuSecondary>
      </MegaMenuContainer>
    </MegaMenu>
  )
}

const ResourceMegaMenu = ({
  resourceMenuOpen,
  onTrialClick,
  onLinkClick,
  pricingLink,
}) => {
  return (
    <MegaMenu className={resourceMenuOpen ? "reveal" : ""}>
      <MegaMenuContainer>
        <MegaMenuMain>
          <MegaMenuMainInner>
            <MegaMenuSubNav>
              <h4>Resources</h4>
              <MegaMenuMainNav>
                <MegaMenuMainNavItem>
                  <Link to="/resources/tour/" onClick={() => onLinkClick()}>
                    Take a Tour
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="https://knowledgebase.mindmemobile.com"
                    target="_blank"
                  >
                    Knowledgebase
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link
                    to="https://knowledgebase.mindmemobile.com/videos"
                    target="_blank"
                  >
                    Videos
                  </Link>
                </MegaMenuMainNavItem>
                <MegaMenuMainNavItem>
                  <Link to="https://blog.mindmemobile.com" target="_blank">
                    Blog
                  </Link>
                </MegaMenuMainNavItem>
              </MegaMenuMainNav>
            </MegaMenuSubNav>
            <MegaMenuMainGraphic>
              <img src={ResourcesGraphic} className="margin-bottom-0" />
              <p>
                <em>
                  <strong>Take a Tour</strong> of our industry leading marketing
                  platform
                </em>
              </p>
            </MegaMenuMainGraphic>
          </MegaMenuMainInner>
        </MegaMenuMain>
        <MegaMenuSecondary>
          <div>
            <h4>Info</h4>
            <MegaMenuMainNav>
              {/* <MegaMenuMainNavItem>
                <Link
                  to="https://meetings.hubspot.com/bert/mindme-demo"
                  target="_blank"
                >
                  Schedule Demo
                </Link>
              </MegaMenuMainNavItem> */}
              <MegaMenuMainNavItem>
                <Link to="/support/" onClick={() => onLinkClick()}>
                  Get Support
                </Link>
              </MegaMenuMainNavItem>
              {/* <MegaMenuMainNavItem>Referral Program</MegaMenuMainNavItem> */}
            </MegaMenuMainNav>
          </div>
          <div>
            <h4>Access</h4>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to={`${config.WEB_ENDPOINT}login`} target="_blank">
                  Account Login
                </Link>
              </MegaMenuMainNavItem>
              <MegaMenuMainNavItem>
                <Link
                  to={`${config.AFFILIATE_WEB_ENDPOINT}affiliate/login`}
                  target="_blank"
                >
                  Affiliate Login
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
          <div>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to="/platform/app/" onClick={() => onLinkClick()}>
                  Mobile App
                </Link>
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
          <div>
            <MegaMenuMainNav>
              <MegaMenuMainNavItem>
                <Link to={pricingLink} onClick={() => onLinkClick()}>
                  View Plans
                </Link>
              </MegaMenuMainNavItem>
              <MegaMenuMainNavItem onClick={(event) => onTrialClick(event)}>
                Free Trial
              </MegaMenuMainNavItem>
            </MegaMenuMainNav>
          </div>
        </MegaMenuSecondary>
      </MegaMenuContainer>
    </MegaMenu>
  )
}

const Menu = ({ stickySubNav, megaMenuOpen, setMegaMenuOpen }) => {
  const themeToggle = useTheme()

  const handleMegaMenu = (menu) => {
    if (!megaMenuOpen.open) {
      setMegaMenuOpen({ open: true, menu })
    }
    if (megaMenuOpen.open && megaMenuOpen.menu === menu) {
      setMegaMenuOpen({ open: false, menu: null })
    }
    if (megaMenuOpen.open && megaMenuOpen.menu !== menu) {
      setMegaMenuOpen({ open: true, menu })
    }
  }

  const onLinkClick = () => {
    if (!megaMenuOpen.open) return
    handleMegaMenu(megaMenuOpen.menu)
  }

  const onTrialClick = (event) => {
    event.preventDefault()
    themeToggle.saveTrialPlan(StandardPlanName.Premium)
    onLinkClick()
  }
  const pricingLink = `/pricing${themeToggle.getPromoQueryParam()}`
  return (
    <>
      <TopNav>
        <TopNavItem className={stickySubNav ? "stickyNav" : ""}>
          <Link to="/resources/tour/" onClick={() => onLinkClick()}>
            Tour
          </Link>
        </TopNavItem>
        <TopNavItem>
          <TopNavDropDownToggle
            onClick={() => handleMegaMenu("platform")}
            className={stickySubNav ? "stickyNav" : ""}
          >
            Platform
          </TopNavDropDownToggle>
          <PlatformMenuMenu
            onTrialClick={onTrialClick}
            onLinkClick={() => onLinkClick()}
            pricingLink={pricingLink}
            platformMenuOpen={megaMenuOpen.menu === "platform"}
          />
        </TopNavItem>
        <TopNavItem>
          <TopNavDropDownToggle
            onClick={() => handleMegaMenu("features")}
            className={stickySubNav ? "stickyNav" : ""}
          >
            Features
          </TopNavDropDownToggle>
          <FeaturesMegaMenu
            onTrialClick={onTrialClick}
            onLinkClick={() => onLinkClick()}
            pricingLink={pricingLink}
            featuresMenuOpen={megaMenuOpen.menu === "features"}
          />
        </TopNavItem>
        <TopNavItem className={stickySubNav ? "stickyNav" : ""}>
          <Link to={pricingLink} onClick={() => onLinkClick()}>
            Pricing
          </Link>
        </TopNavItem>
        <TopNavItem>
          <TopNavDropDownToggle
            onClick={() => handleMegaMenu("resource")}
            className={stickySubNav ? "stickyNav" : ""}
          >
            Resources
          </TopNavDropDownToggle>
          <ResourceMegaMenu
            onTrialClick={onTrialClick}
            onLinkClick={() => onLinkClick()}
            pricingLink={pricingLink}
            resourceMenuOpen={megaMenuOpen.menu === "resource"}
          />
        </TopNavItem>
        <TopNavItem className={stickySubNav ? "stickyNav" : ""}>
          <Link to={`${config.WEB_ENDPOINT}login`} target="_blank">
            Login
          </Link>
        </TopNavItem>
        <TopNavCTA className={stickySubNav ? "stickyNav" : ""}>
          <Link to={pricingLink} onClick={(event) => onTrialClick(event)}>
            Free Trial
          </Link>
        </TopNavCTA>
      </TopNav>
    </>
  )
}

export default Menu

const TopNav = styled.ul`
  align-items: center;
  justify-content: flex-end;
  margin: 0;
  flex: 1;
  z-index: 950;

  ${({ theme }) => theme.se`
    display: none;
  `}

  ${({ theme }) => theme.desktop`
    display: flex;
  `}
`

const TopNavCTA = styled.li`
  margin: 0 10px;
  ${fontBold};
  list-style: none;

  ${({ theme }) => theme.se`
    font-size: 14px;
  `}

  ${({ theme }) => theme.desktop`
    font-size: 16px;
  `}

  ${({ theme }) => theme.largeDesktop`
    font-size: 18px;
  `}

  a {
    text-decoration: none;
    color: #fff;
    background-color: #57ac2d;
    border: 2px solid #57ac2d;
    padding: 10px 20px;
    border-radius: 50px;
    transition: all 200ms linear;
    &:hover {
      background-color: ${brandAccentColor};
      transition: all 200ms linear;
      border: 2px solid ${brandAccentColor};
    }
  }

  &.stickyNav a {
    transition: all 300 linear;
    color: #fff;
    background-color: unset;
    border: 2px solid #fff;
    &:hover {
      background-color: ${brandAccentColor};
      transition: all 200ms linear;
      border: 2px solid ${brandAccentColor};
    }
  }
`

const TopNavItem = styled.li`
  ${fontBold};

  list-style: none;

  ${({ theme }) => theme.se`
    font-size: 14px;
  `}

  ${({ theme }) => theme.desktop`
    font-size: 16px;
    margin: 0 20px;
  `}

  ${({ theme }) => theme.largeDesktop`
    margin: 0 30px;
    font-size: 18px;
  `}

  a {
    text-decoration: none;
    color: ${headlineTextTheme};

    &:hover {
      color: #57ac2d;
      transition: all 200ms linear;
    }
  }

  &.stickyNav > a {
    transition: all 300 linear;
    color: #fff;
  }
`

const TopNavDropDownToggle = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${headlineTextTheme};

  &.stickyNav {
    transition: all 300 linear;
    color: #fff;
  }
`

const MegaMenu = styled.div`
  display: none;
  margin: 0;
  width: 100%;
  background-color: ${megaMenuTheme};
  border: 1px solid ${borderTheme};
  background-color: #f4f4f4;
  position: absolute;
  z-index: 10;
  left: 0;
  top: 94px;

  h4 {
    text-transform: uppercase;
    font-size: 26px;
  }

  &.reveal {
    display: flex;
  }
`

const MegaMenuContainer = styled.div`
  display: flex;
  width: 1400px;
  padding: 0 20px;
  margin: auto;
`

const MegaMenuMain = styled.div`
  ${fontBold};
  font-size: 20px;
  list-style: none;
  background-color: #f4f4f4;
  border-right: 1px solid ${borderTheme};
  width: 60%;
  padding: 40px 0;
  > a {
    text-decoration: none;
    color: ${headlineTextTheme};
  }
`

const MegaMenuMainInner = styled.div`
  display: flex;
  justify-content: space-between;
`

const MegaMenuSubNav = styled.div`
  width: 48%;
`

const MegaMenuMainGraphic = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48%;
  padding: 0 20px;
  .margin-bottom-0 {
    margin-bottom: 0px;
  }
  p {
    ${fontRegular()}
    text-align: center;
  }
`

const MegaMenuMainNav = styled.ul`
  padding-left: 0;
  margin-left: 0;
`

const MegaMenuMainNavItem = styled.li`
  list-style-type: none;
  padding-left: 0;
  margin-left: 0;
  ${fontRegular()}
`
const MegaMenuSecondary = styled.div`
  ${fontBold};
  font-size: 20px;
  list-style: none;
  /* background-color: #ffedee; */
  padding: 40px 0;
  width: 40%;
  > a {
    text-decoration: none;
    color: ${headlineTextTheme};
  }

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  div {
    width: 48%;
    padding: 0 20px;
  }
`
